// import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error, getEditStatusEnum } from '@/store/base/module'
import ApiUtils from '@/utils/api/ApiUtils'


const PageConst= {
  ACTION: {
    doAdd: { api: 'T0030NoticeService.M00101_doSave'},
    getEdit: { api: 'T0030NoticeService.M00101_getEdit'},
    doEdit: { api: 'T0030NoticeService.M00101_doSave'},
    doRead: { api: 'T0030NoticeService.doRead'},
    doDelete: { api: 'T0030NoticeService.doDelete'},
    doBrowse: { api: 'T0030NoticeService.M00101_doBrowse_AtDataTable'},
  },
}

const module = {
  state: {
    PageConst,
    dropdownData: null, // Dropdown data for the notice form
  },

  getters: {

  },

  mutations: {

  },
  actions: {
    async initForm({ commit, state }) {
      commit('setState', {
        getEditStatus: getEditStatusEnum.loading,
      })

      const apis = {
        dropdownData: {
          api: 'T0030NoticeService.M00101_getDropdownData',
          // input: state.row
        }
      }

      // If dropdownData is already set, no need to fetch again
      // if(state.dropdownData) delete apis.dropdownData

      // If row is not set, no need to fetch dropdownData
      if(state.row.notice_no) {
        apis.getEdit = {
          api: 'T0030NoticeService.M00101_getEdit',
          input: state.row
        }
      }

      const res = await ApiUtils.postData({data: apis})

      commit('setState',{
        dropdownData: res.dropdownData.output,
        row: res.getEdit ? res.getEdit.output : state.row,
        getEditStatus: getEditStatusEnum.loaded,
      })
    }
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
